import { render, staticRenderFns } from "./Plan.vue?vue&type=template&id=9a5f033c"
import script from "./Plan.vue?vue&type=script&lang=js"
export * from "./Plan.vue?vue&type=script&lang=js"
import style0 from "./Plan.vue?vue&type=style&index=0&id=9a5f033c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports